/**
 * Custom events used to surface lifecycle changes to host applications.
 */
export const EVENT_STAMPED = 'datocms:visual-editing:stamped';
export const EVENT_CLICK_TO_EDIT_TOGGLE = 'datocms:click-to-edit:toggle';
